import React, { Component, useEffect, useState } from "react";
import baseContentLayout from "./../../shared/base-content/index";
import "./index.scss";
import MyButton from "../../shared/buttons/primary";
import * as actions from "./../../../modules/auth/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import validateSchema from "./validate";
import {
  BLOCK_TIME_OPTIONS,
  BOOKING_REMINDER_TIME_OPTIONS,
  BOOKING_TABLE_TIMES_OPTIONS,
  CITY_BOOKING,
  GOURMET,
} from "../../../constants/app";
import FormSelect from "../../shared/form-select";
import FormSwitch from "../../shared/form-switch";
import ConfirmModal from "./dialog/confirm";
import FormInput from "../../shared/form-input";
import TooltipInfo from "../../shared/tooltip-info";

const Content = (props) => {
  // const globalState = window.store.getState();
  const [shopDetail, setShopDetail] = useState({});
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});
  const [isChangeBlockTime, setIsChangeBlockTime] = React.useState(false);
  const [confirmModal, setConfirmModal] = React.useState({
    message: "",
    isShow: false,
  });
  const { user } = window.store.getState().auth;
  const isGourmet = user.category_type === GOURMET;
  const isCityBooking = user.city_name === CITY_BOOKING;

  useEffect(() => {
    setShopDetail(user);
  }, [user]);

  async function changeBookingConfirmStatus(e) {
    const { checked } = e.target;
    handleUpdateShopInfor("booking_confirm", checked);
  }

  function getShopInfor() {
    return window.axios({
      url: `shop/${window.store.getState().auth.user.id}/`,
      method: "get",
    });
  }

  function updateShopInfo(data) {
    return window.axios({
      url: `shop/${window.store.getState().auth.user.id}/`,
      method: "patch",
      data,
    });
  }

  function copyLink() {
    const copyButton = document.querySelector(".common-view__copy-btn");
    copyButton.classList.remove("common-view__copy-btn--animate");
    copyButton.classList.add("common-view__copy-btn--animate");

    setTimeout(() => {
      copyButton.classList.remove("common-view__copy-btn--animate");
    }, 1000);

    let textArea = document.querySelector("textarea.js-for-copy-element");
    const link = `${process.env.REACT_APP_USER_BASE_URL}${
      window.store.getState().auth.user.id
    }/booking`;

    textArea = document.createElement("textarea");
    textArea.classList.add("js-for-copy-element");
    document.body.append(textArea);
    textArea.textContent = link;
    textArea.select();
    document.execCommand("copy");

    document.body.removeChild(textArea);
  }

  const handleUpdateShopInfor = (name, value) => {
    if (!name) return false;

    updateShopInfo({ [name]: value }).then(() => {
      getShopInfor().then(({ data }) => {
        const { loginActions } = props;
        loginActions.setUser(data);
      });
    });
  };

  const validate = () => {
    const { error } = validateSchema.validate(shopDetail);
    let _errorMsg = {};
    let isValid = true;

    setErrorMsg(_errorMsg);

    if (error) {
      error.details.forEach((err) => {
        _errorMsg[err.context.label] = err.message;
      });

      isValid = false;
    }
    setErrorMsg(_errorMsg);

    return isValid;
  };
  const saveSetting = () => {
    setIsBtnDisabled(true);
    const isValid = validate();

    if (!isValid) {
      setIsBtnDisabled(false);
      return;
    }

    let updateData = {
      section_name_1: shopDetail.section_name_1,
      has_child_tables: shopDetail.has_child_tables,
      booking_time_block: shopDetail.booking_time_block,
      booking_reminder_time: shopDetail.booking_reminder_time,
    };

    if (isCityBooking) {
      if (isGourmet) {
        updateData["show_tables"] = shopDetail.show_tables;
      } else {
        updateData["show_staff"] = shopDetail.show_staff;
      }
      updateData["show_menu"] = shopDetail.show_menu;
      updateData["note"] = shopDetail.note;
      updateData["stay_duration"] = Number(shopDetail.stay_duration);
    }

    updateShopInfo(updateData)
      .then(() => {
        getShopInfor().then(({ data }) => {
          const { loginActions } = props;
          loginActions.setUser(data);
          onCloseConfirmModal();
        });
      })
      .finally(() => {
        setIsBtnDisabled(false);
        onCloseConfirmModal();
      });
  };

  const handleChange = (name, value) => {
    setShopDetail({
      ...shopDetail,
      [name]: value,
    });
  };

  const onCloseConfirmModal = () => {
    setConfirmModal({
      isShow: false,
      message: "",
    });
  };

  const handleSaveSetting = () => {
    if (isChangeBlockTime) {
      setConfirmModal({
        isShow: true,
        message:
          "「ブロック時間の変更は、既存の予約に影響します。本当に変更しますか？」",
      });
    } else {
      saveSetting();
    }
  };

  return (
    <div className="common-view">
      <div className="booking-form__row">
        <div className="booking-form__label">
          <label className="form-label user-select-none d-flex align-items-center">
            予約承認必要？
            <TooltipInfo title="顧客が予約を行った際、店舗が承認してから予約を確定させる設定です。オンにすると、予約は「承認待ち」状態となり、店舗の承認後に確定します。" />
          </label>
        </div>
        <div className="booking-form__control">
          <div className="form-switch">
            <input
              checked={shopDetail.booking_confirm || ""}
              className="form-check-input"
              type="checkbox"
              onChange={changeBookingConfirmStatus}
            />
          </div>
        </div>
      </div>
      <div className="booking-form__row">
        <div className="booking-form__label">
          <label className="form-label user-select-none d-flex align-items-center">
            URL取得
            <TooltipInfo title="店舗の予約画面へのリンクURLをコピーできます。SNSやホームページで共有したり、直接顧客に送ることで簡単に予約してもらうことができます。" />
          </label>
        </div>
        <div className="booking-form__control booking-form__control--link">
          <a
            href={`${process.env.REACT_APP_USER_BASE_URL}${
              window.store.getState().auth.user.id
            }/booking`}
            target="_blank"
            rel="noreferrer"
          >{`${process.env.REACT_APP_USER_BASE_URL}${
            window.store.getState().auth.user.id
          }/booking`}</a>
          <div className="common-view__copy-btn" onClick={copyLink}>
            <span className="material-icons">content_copy</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="#000000"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
            </svg>
          </div>
        </div>
      </div>
      <div className="booking-form__row">
        <div className="booking-form__label">
          <label className="form-label user-select-none d-flex align-items-center">
            スタッフタブ名編集
            <TooltipInfo title="予約管理画面の左コースに表示される「スタッフ」タブの名称を編集できます。業種に応じて「医師」「施術者」「スタイリスト」などに変更可能です。" />
          </label>
        </div>
        <div className="booking-form__control">
          <div className="common-view__input-with-count">
            <input
              className="form-control "
              value={shopDetail.section_name_1 || ""}
              maxLength="20"
              onBlur={validate}
              onChange={(e) => {
                setShopDetail({
                  ...shopDetail,
                  section_name_1: e.target.value,
                });
              }}
            />
            <span className="common-view__count">
              {shopDetail.section_name_1?.length}/20
            </span>
          </div>

          {errorMsg["section_name_1"] && (
            <p className="error-text">{errorMsg["section_name_1"]}</p>
          )}
        </div>
      </div>
      {isCityBooking && (
        <>
          {/* Child seat */}
          <div className="booking-form__row">
            <div className="booking-form__label">
              <label className="form-label user-select-none d-flex align-items-center">
                子供用椅子あり
                <TooltipInfo title="店舗に子供用の椅子が用意されているかどうかの設定です。" />
              </label>
            </div>
            <div className="booking-form__control">
              <input
                checked={shopDetail.has_child_tables}
                className="form-check-input"
                type="checkbox"
                onChange={(e) => {
                  const { checked } = e.target;
                  handleChange("has_child_tables", checked);
                }}
              />
            </div>
          </div>
          <FormSelect
            onChange={(value) => {
              handleChange("booking_time_block", value);
              setIsChangeBlockTime(true);
            }}
            valueSelected={shopDetail.booking_time_block || 10}
            options={BLOCK_TIME_OPTIONS}
            label="時間枠の設定"
            labelInfo={`予約受付可能な時間帯（ブロック）を設定できます。営業時間内で複数の時間帯を作成し、ユーザーが選べるようにします。`}
          />
          <FormSelect
            onChange={(value) => {
              handleChange("stay_duration", value);
            }}
            valueSelected={shopDetail.stay_duration || 30}
            options={BOOKING_TABLE_TIMES_OPTIONS}
            label="席だけ予約の滞在時間"
          />
          <FormSelect
            onChange={(value) => handleChange("booking_reminder_time", value)}
            valueSelected={shopDetail.booking_reminder_time || 15}
            options={BOOKING_REMINDER_TIME_OPTIONS}
            label="リマインド通知"
            noteInfo="※ 予約時間の前にリマインド通知を送信する機能です。
              リマインド時間を15分～24時間以内に設定した場合、プッシュ通知にキャンセルボタンは表示されません。
              2日以上前に設定した場合は、「確認しました」と「キャンセル」ボタンが表示されます。"
          />
          <div className="booking-form__reservation-items">
            <b className="form-label user-select-none d-flex align-items-center">
              <label>
                予約項目の表示・非表示設定
                <TooltipInfo title="予約画面で表示する項目を選択できます。必要に応じて非表示にできます。" />
              </label>
            </b>
            <div className="booking-form__reservation-items-form">
              {isGourmet ? (
                <FormSwitch
                  label="席"
                  checkedValue={shopDetail.show_tables}
                  onChange={(value) => {
                    handleChange("show_tables", value);
                  }}
                />
              ) : (
                <FormSwitch
                  label="スタッフ"
                  checkedValue={shopDetail.show_staff}
                  onChange={(value) => {
                    handleChange("show_staff", value);
                  }}
                />
              )}
              <FormSwitch
                label={isGourmet ? "コース" : "メニュー"}
                checkedValue={shopDetail.show_menu}
                onChange={(value) => {
                  handleChange("show_menu", value);
                }}
              />
            </div>
          </div>

          <div className="booking-form__reservation-items m-0">
            <div className="d-flex align-items-center">
              <b>注意事項・キャンセルポリシー</b>
              <TooltipInfo title="予約前に顧客に表示される注意事項やキャンセルポリシーを入力します。" />
            </div>
            <div className="booking-form__reservation-items-form">
              <FormInput
                className="form-control resize-none"
                onChange={(value) => {
                  setShopDetail({
                    ...shopDetail,
                    note: value,
                  });
                }}
                inputType="textarea"
                rows="12"
                onBlur={validate}
                placeholder="注意事項・キャンセルポリシー"
                value={shopDetail.note || ""}
                name="note"
                maxLength="1000"
                autoFocus
                showCount
              />
              {errorMsg["note"] && (
                <p className="error-text">{errorMsg["note"]}</p>
              )}
            </div>
          </div>
        </>
      )}
      <div className="common-view__buttons">
        <MyButton
          myVariant="create"
          isLoading={isBtnDisabled}
          onClick={handleSaveSetting}
        >
          確定
        </MyButton>
      </div>
      {confirmModal.isShow && isCityBooking && (
        <ConfirmModal
          message={confirmModal.message}
          onClose={onCloseConfirmModal}
          onAccept={saveSetting}
        />
      )}
    </div>
  );
};
const StaffContent = baseContentLayout(Content);

class index extends Component {
  render() {
    return <StaffContent name="共通設定" {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => ({
  loginActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(index);
